import type { SelfServiceAPI } from 'types';

const getRefundableText = (cancellationType: SelfServiceAPI.CancellationWindowType) => {
  switch (cancellationType) {
    case 'FULLY_REFUNDABLE':
      return 'Full refund';
    case 'PARTIALLY_REFUNDABLE':
      return 'Partial refund';
    case 'NON_REFUNDABLE':
      return 'Non-refundable';
    default:
      return '';
  }
};

export default getRefundableText;
